import { Component, OnInit, OnDestroy } from '@angular/core';
import { ApplicationInfo, EnvironmentService } from '@abp/ng.core';
import { BrandingSettingsService } from '../../settings/branding-settings/proxy/branding-settings.service';
import { BrandingSettingsDto } from '../../settings/branding-settings/proxy/branding-settings.model';

@Component({
  selector: 'cai-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  standalone: false,
})
export class FooterComponent implements OnInit, OnDestroy {
  currentYear = new Date().getFullYear();
  showAIUsageDisclaimer = false;
  footerText: string = '2021 - ' + this.currentYear + ' | AI Agents | Sestek';

  constructor(
    private environment: EnvironmentService,
    private brandingSettingsService: BrandingSettingsService,
  ) {}

  ngOnInit(): void {
    this.loadFooterText();

    // Listen for branding updates
    window.addEventListener('branding-updated', this.handleBrandingUpdate.bind(this));
  }

  ngOnDestroy(): void {
    window.removeEventListener('branding-updated', this.handleBrandingUpdate.bind(this));
  }

  get appInfo(): ApplicationInfo {
    return this.environment.getEnvironment().application;
  }

  private loadFooterText(): void {
    this.brandingSettingsService.get().subscribe({
      next: (settings: BrandingSettingsDto) => {
        if (settings.footerText) {
          this.footerText = `2021 - ${this.currentYear} | ${settings.footerText}`;
        }
      },
      error: (err) => {
        console.error('Error loading footer text:', err);
      },
    });
  }

  private handleBrandingUpdate(event: Event): void {
    const customEvent = event as CustomEvent<BrandingSettingsDto>;
    if (customEvent.detail?.footerText) {
      this.footerText = `2021 - ${this.currentYear} | ${customEvent.detail.footerText}`;
    }
  }
}
